import { Link } from "react-router-dom";
import { Instagram, Mail, Phone, MapPin, MessageCircle } from "lucide-react";
import { fmtPhone, mapsUrl } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { useLang } from "@/context/LangContext";
import { useStore } from "@/context/StoreContext";
import { waLink } from "@/lib/api";

export function Footer() {
  const { t, tr } = useLang();
  const { settings: s } = useStore();
  const address = tr(s?.address);
  const year = new Date().getFullYear();
  const contacts = [
    s?.contact_phone && { icon: Phone, label: s.contact_phone, href: `tel:${s.contact_phone}`, id: "phone" },
    s?.contact_email && { icon: Mail, label: s.contact_email, href: `mailto:${s.contact_email}`, id: "email" },
    s?.whatsapp_number && { icon: MessageCircle, label: `WhatsApp · ${fmtPhone(s.whatsapp_number)}`, href: waLink(s.whatsapp_number, t("wa_contact_msg")), id: "whatsapp" },
    s?.instagram && { icon: Instagram, label: "Instagram", href: s.instagram, id: "instagram" },
    address && { icon: MapPin, label: address, href: mapsUrl(s.address?.fr || address), id: "address", rtlText: true },
  ].filter(Boolean);

  return (
    <footer data-testid="site-footer" className="relative overflow-hidden bg-[#0B0B0C] text-[#F7F3EB]">
      <div className="mx-auto max-w-[1440px] px-5 pt-24 sm:px-10">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2">
          <Logo />
          {contacts.length > 0 && (
            <div>
              <p className="eyebrow">{t("contact")}</p>
              <ul className="mt-6 space-y-3">
                {contacts.map((c) => (
                  <li key={c.id}>
                    {c.href ? (
                      <a data-testid={`footer-contact-${c.id}`} href={c.href} target={c.href.startsWith("http") ? "_blank" : undefined} rel="noreferrer" className="inline-flex items-center gap-3 text-sm text-[#F7F3EB]/80 transition-colors hover:text-[#C6A76A]">
                        <c.icon className="h-4 w-4 text-[#C6A76A]" strokeWidth={1.2} /> <span dir={c.rtlText ? undefined : "ltr"}>{c.label}</span>
                      </a>
                    ) : (
                      <span className="inline-flex items-center gap-3 text-sm text-[#F7F3EB]/80">
                        <c.icon className="h-4 w-4 text-[#C6A76A]" strokeWidth={1.2} /> {c.label}
                      </span>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
        <p className="pointer-events-none mt-20 select-none text-center font-arabic-display text-[26vw] leading-[0.9] text-[#F7F3EB]/[0.04] md:text-[20vw]" aria-hidden>
          رويحة
        </p>
        <div className="flex flex-col items-center justify-between gap-4 border-t border-[#F7F3EB]/10 py-8 text-xs text-[#F7F3EB]/60 sm:flex-row">
          <span>© {year} ATOR RWIHA — عطور رويحة. {t("rights")}.</span>
          <Link to="/contact" data-testid="footer-contact-link" className="link-line pb-0.5 hover:text-[#F7F3EB]">
            {t("contact")}
          </Link>
          <Link to="/admin" data-testid="footer-admin-link" className="link-line pb-0.5 hover:text-[#F7F3EB]">
            {t("store_admin")}
          </Link>
        </div>
      </div>
    </footer>
  );
}
